import { css } from 'react-emotion';
import { colors, fontFamily, heights } from '../../variables';

export namespace styles {
  export const row = (inGroup: boolean = false, groupFirst: boolean = false, groupLast: boolean = false) =>
    css({
      fontFamily,
      backgroundColor: '#fff',
      height: heights.INPUT_HEIGHT,
      border: !inGroup ? '1px solid' : undefined,
      borderColor: colors.light,
      borderRadius: '.3rem',
      padding: !inGroup ? '.65rem 1rem' : '.25rem 0',
      marginTop: groupLast ? '8px' : undefined,
      marginBottom: groupFirst ? '8px' : undefined,
      margin: !inGroup ? '8px 0' : '0',
      fontSize: '1rem',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box'
    });

  export const groupBreak = css({
    borderBottom: '1px solid',
    borderColor: colors.light
  });
}
